import * as React from "react";

function SvgTasksOutlined(props) {
  return <svg viewBox="0 0 38 42" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19 .083c-2.717 0-5.007 1.744-5.867 4.167H4.417A4.166 4.166 0 00.25 8.417v29.166a4.166 4.166 0 004.167 4.167h29.166a4.166 4.166 0 004.167-4.167V8.417a4.166 4.166 0 00-4.167-4.167h-8.715C24.008 1.827 21.716.083 19 .083zm0 4.167a2.084 2.084 0 010 4.167h14.583v29.166H4.417V8.417H19a2.084 2.084 0 010-4.167zm6.86 11.027l-8.943 8.944-4.777-4.777-2.946 2.946 7.723 7.723 11.89-11.89-2.947-2.946z" /></svg>;
}

export default SvgTasksOutlined;